<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import copyright from '@/components/copyright.vue'
import titlebar from '@/components/titlebar.vue'
import dmDialog from '@/components/dialog.vue'
import Vue from 'vue'
import Store from 'store'
import observe from 'store/plugins/observe'
Store.addPlugin(observe)
Vue.component('copyright', copyright)
Vue.component('TitleBar', titlebar)
Vue.component('dm-dialog', dmDialog)
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState({
      token: state => state.login.token
    }),
    cskin () {
      const skin = Vue.cookie("skin")
      return skin ? `ui-cskin-${skin}` : ''
    }
  },
  methods: {
    ...mapMutations({
      setToken: 'SET_TOKEN_BY_STORE'
    }),
    ...mapActions(['getUserInfo', 'collect', 'getChannelConf'])
  },
  mounted () {
    this.collect()
    this.getChannelConf()
    Store.observe('token', (val) => {
      this.setToken(val)
    })
  }
}
</script>
<style>
::-webkit-input-placeholder {
  color: #CCCCCC;
}
:-moz-placeholder {
  color: #CCCCCC;
}
::-moz-placeholder {
  color: #CCCCCC;
}
:-ms-input-placeholder {
  color: #CCCCCC;
}
.td_l {
  text-align: left;
}
.td_r {
  text-align: right;
}
.pull-right {
  float: right;
}
.text-center {
  text-align: center;
}
</style>
<style lang="stylus">
// lib
@import '~dmx/demo/css/h5_wallet.css'

// base
@import './config/aiqiyi_themes_var'
@import './stylus/common/base'

// components
@import './stylus/components/pcenter'

// pages
@import './stylus/index'
@import './stylus/index-redirect'
@import './stylus/bank-valid'
@import './stylus/contract'
@import './stylus/cmbc'
@import './stylus/apply/bank'
@import './stylus/apply/detail'
@import './stylus/apply/schedule'
@import './stylus/apply/history'
@import './stylus/apply/info'
@import './stylus/apply/profile'
@import './stylus/apply/proving'
@import './stylus/apply/result'
@import './stylus/apply/result-no'
@import './stylus/coupons/coupon-fragment'
@import './stylus/coupons/coupon-index'
@import './stylus/coupons/coupon'
@import './stylus/coupons/list'
@import './stylus/loan/index'
@import './stylus/loan/plan'
@import './stylus/loan/result'
@import './stylus/loan/sign'
@import './stylus/loan/log'
@import './stylus/login/index'
@import './stylus/protocols/index'
@import './stylus/question/check'
@import './stylus/question/cmbc'
@import './stylus/question/hot'
@import './stylus/question/index'
@import './stylus/question/invoice'
@import './stylus/question/production'
@import './stylus/question/repay'
@import './stylus/question/security'
@import './stylus/question/withdraw'
@import './stylus/repay/await'
@import './stylus/repay/center'
@import './stylus/repay/cards'
@import './stylus/repay/index'
@import './stylus/repay/list'
@import './stylus/repay/prepayment'
@import './stylus/supplement/eg'
@import './stylus/supplement/identity-result'
@import './stylus/supplement/identity'
@import './stylus/supplement/info'
@import './stylus/supplement/vendor'
@import './stylus/user/auto-payment-open'
@import './stylus/user/auto-payment'
@import './stylus/user/banks'
@import './stylus/user/profile-menu'
@import './stylus/user/profile'
@import './stylus/user/security-mobile'
@import './stylus/user/security-pwd'
@import './stylus/user/security'
@import './stylus/extension/index'
@import './stylus/duoqidai'
@import './stylus/download'
@import './stylus/daoliu/loading'
@import './stylus/daoliu/vendor'
@import './stylus/daoliu/repay'
@import './stylus/skin'
</style>
